import React from "react";
import type { LucideIcon } from "lucide-react";

interface AuthCardProps {
  icon: LucideIcon;
  title: string;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
}

const AuthCard = ({ icon: Icon, title, subtitle, children }: AuthCardProps) => {
  return (
    <div className="flex flex-1 items-center justify-center px-4 py-16">
      <div className="w-full max-w-md rounded-[18px] border border-[#e1e9e9] bg-white p-8 shadow-[0_7px_24px_rgba(7,46,64,0.06)] sm:p-10">
        <span className="grid size-14 place-items-center rounded-full bg-mint">
          <Icon className="size-7 text-brand-ink" strokeWidth={1.75} aria-hidden />
        </span>
        <h1 className="mt-6 text-2xl font-bold tracking-tight text-navy">{title}</h1>
        {subtitle && <p className="mt-2 text-[15px] leading-relaxed text-slate-600">{subtitle}</p>}
        <div className="mt-8">{children}</div>
      </div>
    </div>
  );
};

export default AuthCard;
